/**
 * @class Configuration
 *
 * Reads environment configuration from window.CONSTANTS, which is set by the
 * parent site (environments.js + CONSTANTS.js) before this Vue app loads.
 * This avoids duplicating domain-to-config mappings in two places.
 */
export default class Configuration {

	static currentConfiguration() {
		const constants = window.CONSTANTS;

		// Localhost fallback when running outside the parent site
		if (!constants) {
			return {
				VUE_APP_ZESTY_ENDPOINT: 'https://7q79g7zj-dev.preview.zesty.io',
				VUE_APP_API_ENDPOINT: 'http://localhost:8080',
				VUE_APP_LOGIN_REDIRECT: '/login/',
				VUE_APP_PROFILE_URL: '/member/#/',
				VUE_APP_EDIT_URL: '/account/#/',
				VUE_APP_API_HEADERS_XEnv: 'sandbox',
				VUE_APP_API_HEADERS_XEnvBraintree: 'sandbox',
				SENTRY_ENVIRONMENT: 'other',
				M_DCIM_CLIENT_ID: '757152e0-ab56-4160-8afa-151a466f4da5',
				M_DCIM_ENDPOINT: 'https://account.cassia.io',
				LOGIN_FLOW: 'mdcim-optional',
			};
		}

		const isProd = constants.ENV === 'production';
		const sandboxHeader = isProd ? '' : 'sandbox';

		return {
			VUE_APP_ZESTY_ENDPOINT: window.location.origin,
			VUE_APP_API_ENDPOINT: constants.API_ENDPOINT,
			VUE_APP_LOGIN_REDIRECT: '/newlogin/',
			VUE_APP_PROFILE_URL: '/member/#/',
			VUE_APP_EDIT_URL: '/account/#/',
			VUE_APP_API_HEADERS_XEnv: sandboxHeader,
			VUE_APP_API_HEADERS_XEnvBraintree: sandboxHeader,
			SENTRY_ENVIRONMENT: isProd ? 'production' : 'staging',
			M_DCIM_CLIENT_ID: constants.M_DCIM_CLIENT_ID,
			M_DCIM_ENDPOINT: constants.M_DCIM_ENDPOINT,
			LOGIN_FLOW: constants.LOGIN_FLOW,
		};
	}

}
